export const TEMPLATE_STATUS = {
	DELETED: 'DELETED',
	INACTIVE: 'INACTIVE',
	ACTIVE: 'ACTIVE',
};
